/* eslint-disable no-unused-vars */
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import React, { useState, useEffect } from 'react'
import { OTHER_REASON_ID } from 'src/core/helpers'
import { offsetReasonListSelector } from 'src/features'
import { Row, Select, Divider, FormInstance } from 'antd'
import { getOffsetReasonsTranslated } from 'src/core/json'
import { CustomSelect, FormLabels, CustomCol, CustomTextArea } from 'src/components'

interface BrokerageOffsetReasonFieldProps {
  form: FormInstance
  currentOffsetReason: number
  setCurrentOffsetReason: (value: number) => void
}

const BrokerageOffsetReasonField: React.FC<BrokerageOffsetReasonFieldProps> = (props) => {
  const { t } = useTranslation()
  const { form, setCurrentOffsetReason, currentOffsetReason } = props
  const { loading, data: reasonList } = useAppSelector(offsetReasonListSelector)
  const [isOffsetTextVisible, setIsOffsetTextVisible] = useState(false)
  const reasonListTranslated = getOffsetReasonsTranslated(reasonList)

  const handleReasonChange = (value: number) => {
    setCurrentOffsetReason(value)
    setIsOffsetTextVisible(value === OTHER_REASON_ID)
    form.resetFields(['offset_reason_text'])
  }

  useEffect(() => {
    if (!currentOffsetReason) { setIsOffsetTextVisible(false) }
    setIsOffsetTextVisible(currentOffsetReason === OTHER_REASON_ID)
  }, [currentOffsetReason])

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('admin.Brokerage.OffsetReason')}
        subtitle={t('admin.Brokerage.OffsetReasonLabel')}
      />
    </CustomCol>
    <CustomCol>
      <CustomSelect
        name='offset_reason'
        placeholder={t('admin.Brokerage.OffsetReasonPlaceholder')}
        onChange={handleReasonChange}
        loading={loading}
      >
        {reasonListTranslated.map(reason => (
          <Select.Option value={reason.id} key={reason.id}>
            {reason.text}
          </Select.Option>
        ))}
      </CustomSelect>
      {isOffsetTextVisible && <>
        <Divider />
        <CustomTextArea
          name='offset_reason_text'
          placeholder={t('admin.Brokerage.ReasonPlaceholder')}
          rows={2}
        />
      </>}
    </CustomCol>
  </Row>
}

export default BrokerageOffsetReasonField
